import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// Города, для которых действуют ограничения интерфейса (710000000 — Астана)
const RESTRICTED_CITIES = ["710000000"];

export default new Vuex.Store({
  state: {
    user: {},
  },
  getters: {
    // Пользователь такого города видит только Учет, Товары в наличии и Накладные
    isCityRestricted: (state) =>
      Array.isArray(state.user.cities) &&
      state.user.cities.some((city) =>
        RESTRICTED_CITIES.includes(String(city))
      ),
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
  },
  actions: {},
  modules: {},
});
